import httpManager from "@/app/shared/utils/httpManager";

export async function validateTokenWorkTeam(token) {
  const url = "/settings/recovery/account/verify-token/";
  return httpManager.post(url, { token }, { isPublic: true });
}
